<template>
    <div class="page choose-office">
        <div class="choose-office-title">{{title}}</div>
        <van-tree-select height="calc(100vh - 150px)" :items="officeClass" :main-active-index.sync="officeClassInd" @click-nav="clickClass" selected-icon="success">
            <template #content>
                <van-radio-group v-model="officeInd" @change="changeOffice">
                    <van-cell-group>
                        <van-cell v-for="(item, index) in office" clickable :key="index" :title="item.name" @click="officeInd = index">
                            <template #right-icon>
                                <van-radio :name="index" ref="checkboxes" checked-color="#D3172E" />
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
            </template>
        </van-tree-select>

        <div class="choose-office-confirm">
            <van-cell class="choose-office-confirm-cell">
                <template slot="title">
                    <div class="choose-office-confirm-left">已选：</div>
                    <div class="choose-office-confirm-content">{{ formData.office_name }}</div>
                    <van-button class="choose-office-confirm-btn" type="danger" @click="chooseOffice()" color="#D3172E" round size="small">确定</van-button>
                </template>
            </van-cell>
        </div>
    </div>
</template>

<script>
    import Interface from '@/util/interface'
    export default {
        name: 'home',
        data() {
            return {
                formData: {},
                index: '',
                officeClassInd: '',
                officeInd: '',
                officeClass: [],
                office: [],
                list: [],
                pId: '',
                isMajor: false
            }
        },
        computed: {
            title() {
                let str = this.isMajor ? '专业列表' : '科室列表'
                return str
            },

        },
        methods: {
            changeOffice(val) {
                console.log('val:', val, val === '')
                if (val === '') return
                this.formData.office_name = this.office[val].name
                this.formData.office_id = this.office[val].id
                this.pId = this.office[val].parent_id
                this.index = val
            },
            clickClass(val) {
                this.office = this.officeClass[val].children
                this.officeInd = this.officeClass[val].id == this.pId ? this.index : ''
            },
            fetch(scene) {
                if (scene === 'office') {
                    Interface.getData('get', Interface.user.office, {
                        // hospital_id: this.formData.hospital_id,
                        // pageSize: 999
                    }).then((res) => {
                        if (res.code == 0) {
                            this.officeClass = res.data.map(item => {
                                item.text = item.name
                                return item
                            })
                            this.init()
                        }
                    })
                } else if (scene === 'major') {
                    Interface.getData('get', Interface.user.major, {
                        // hospital_id: this.formData.hospital_id,
                        // pageSize: 999
                    }).then((res) => {
                        if (res.code == 0) {
                            this.officeClass = res.data.map(item => {
                                item.text = item.name
                                return item
                            })
                            this.init()
                        }
                    })
                }
            },
            chooseOffice() {
                let data = JSON.parse(localStorage.getItem('add-info'))
                data.office_name = this.office[this.officeInd].name
                data.office_id = this.office[this.officeInd].id
                localStorage.setItem('add-info', JSON.stringify(data))
                this.$router.push({
                    name: "add-info"
                })
            },
            init() {
                if(!this.formData.office_id) {
                    this.officeClassInd = 0
                    this.office = this.officeClass[this.officeClassInd].children
                    this.officeInd = ''
                    this.index = ''
                    return 
                }
                this.pId = this.getParentId(this.officeClass, this.formData.office_id)
                this.officeClassInd = this.officeClass.findIndex(item => item.id === this.pId)
                this.office = this.officeClass[this.officeClassInd].children
                this.officeInd = this.office.findIndex(item => item.id === this.formData.office_id)
                this.index = this.officeInd
                console.log('init:', this.officeClassInd, this.officeInd)
            },
            getParentId(list, id) {
                let result = [],
                    ind = ''
                list.forEach(ele => {
                    if (ele.children.length > 0) result.push(...ele.children)
                });
                ind = result.findIndex(item => item.id === id)
                return result[ind].parent_id || ''
            }
        },
        created() {
            this.isMajor = this.$route.query && this.$route.query.isMajor == 1 ? true : false
            this.formData = JSON.parse(localStorage.getItem('add-info'))
            // if (!this.formData.office_id) this.formData.office_id = 30
            Interface.getShareInfo(this, '', '', '')
            if (this.isMajor) {
                this.fetch('major')
            } else {
                this.fetch('office')
            }

        }
    }
</script>

<style lang="scss">
    @import './index-new.scss';
</style>


// WEBPACK FOOTER //
// src/views/login/choose-office/index-new.vue